import { Text, Modal as ModalBase } from '@village/ui';
import styled from 'styled-components';
import { device } from 'utils/device';

const Modal = styled(ModalBase)`
    z-index: 30;
`;

const ModalWrapper = styled.div`
    padding: 1.5rem;

    @media ${device.maxTablet} {
        padding: 1rem;
        width: calc(100vw - 1.5rem);
    }

    @media ${device.minTablet} {
        width: 40em;
    }
`;

const ModalHeaderTitle = styled(Text)`
    margin-bottom: 1rem;
`;

const ModalMessageTitle = styled(Text)`
    color: #4a4a4a;
`;

const IconContainer = styled.div`
    height: 4.25rem;
    min-width: 4.25rem;
    border-radius: 50%;
    background-color: rgba(211, 232, 236, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;

    @media ${device.maxTablet} {
        display: none;
    }
`;

const FooterSection = styled.footer`
    display: grid;
    padding-top: 1rem;
    gap: 2rem;
    justify-content: right;
    grid-template-columns: 0.3fr 0.5fr;

    @media ${device.maxTablet} {
        flex-direction: column-reverse;
        display: flex;
        gap: 1rem;
    }
`;

const ModalHeaderSection = styled.div`
    display: flex;
    flex-direction: row;
    gap: 1.5rem;
`;

export { ModalHeaderTitle, ModalMessageTitle, ModalHeaderSection, FooterSection, Modal, IconContainer, ModalWrapper };
